module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"charactersLimit":"Максимальное количество символов","enterTheCorrectAnswer":"Введите правильный ответ*","enterTheAnswer":"Введите ответ*","noCorrectAnswer":"Нет правильного ответа","showTheCorrectAnswer":"Укажите правильный ответ","requiredField":"Обязательное поле для заполнения"}}')
  delete Component.options._Ctor
}
